import React from 'react';
import { motion } from 'framer-motion';
export function JourneyPath() {
  return <div className="fixed left-8 top-1/2 -translate-y-1/2 z-30 hidden lg:block" data-id="element-75">
      <div className="relative" data-id="element-76">
        {/* Vertical path line */}
        <motion.div initial={{
        height: 0
      }} animate={{
        height: '100%'
      }} transition={{
        duration: 2,
        ease: 'easeOut'
      }} className="absolute left-1/2 -translate-x-1/2 w-0.5 h-96 bg-gradient-to-b from-purple-500/50 via-cyan-500/50 to-purple-500/50" data-id="element-77" />
        {/* Journey markers */}
        {[{
        label: 'Start',
        top: '0%'
      }, {
        label: 'The Problem',
        top: '20%'
      }, {
        label: 'The Solution',
        top: '35%'
      }, {
        label: 'The Masters',
        top: '50%'
      }, {
        label: 'The Offer',
        top: '65%'
      }, {
        label: 'The Transformation',
        top: '85%'
      }].map((marker, index) => <motion.div key={marker.label} initial={{
        opacity: 0,
        scale: 0
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: index * 0.3,
        duration: 0.5
      }} className="absolute left-1/2 -translate-x-1/2" style={{
        top: marker.top
      }} data-id="element-78">
            <div className="relative group" data-id="element-79">
              <div className="w-3 h-3 rounded-full bg-gradient-to-r from-purple-500 to-cyan-500 shadow-lg shadow-purple-500/50" data-id="element-80" />
              <div className="absolute left-6 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap" data-id="element-81">
                <span className="text-xs text-cyan-400 font-medium" data-id="element-82">
                  {marker.label}
                </span>
              </div>
            </div>
          </motion.div>)}
      </div>
    </div>;
}